export default {
  "b2b.form-switches.typy-zdroju.label": "Resource type",
  "b2b.form-switches.zdroje.label": "Resource",
  "b2b.form-switches.produkty.label": "Service specification"
};
